import { useEffect, useState } from "react";
import { Lab } from "../../../backend/src/types";
import DiscardedList from "../components/alerts/Discarded";
import ExpireSoonList from "../components/alerts/Expire_soon";
import LowQuantityList from "../components/alerts/LowQuantity";
import LoadingOverlay from "../components/Loading";
import { useUser } from "../contexts/UserContext";
import { getAlertCountByLabs } from "../fetch/AlertRequest";
import styles from "../styles/modules/MainPage.module.css";
import "../styles/sanitize.css";

function MainPage() {
  const { user, userLabs, memberships, alertCount } = useUser();

  const [selectedLab, setSelectedLab] = useState<Lab | null>(null);
  const [isLabAdmin, setIsLabAdmin] = useState<boolean>(false);

  //オブジェクトにまとめたらuseEffectで無限ループしたため個別にStateで
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isDiscardedFinish, setIsDiscardedFinish] = useState(false);
  const [isExpireSoonFinish, setIsExpireSoonFinish] = useState(false);
  const [isLowQuantityFinish, setIsLowQuantityFinish] = useState(false);
  const [alertCountByLabs, setAlertCountByLabs] = useState<Map<number, number>>(
    new Map(),
  );

  useEffect(() => {
    if (userLabs) setSelectedLab(userLabs[0]);
  }, [userLabs, memberships]);

  useEffect(() => {
    if (selectedLab) initLoadingState();
  }, [selectedLab]);

  useEffect(() => {
    if (userLabs) loadAlertCountByLabsMap(userLabs);
  }, [userLabs, alertCount]);

  async function loadAlertCountByLabsMap(userLabs: Lab[]) {
    const lab_ids = userLabs.map((lab) => lab.id);
    const tenant_id = user?.tenant_id;
    if (tenant_id) {
      const map = await getAlertCountByLabs({ tenant_id, lab_ids });
      setAlertCountByLabs(map);
    }
  }

  useEffect(() => {
    if (
      isDiscardedFinish &&
      isExpireSoonFinish &&
      isLowQuantityFinish &&
      isLoading
    ) {
      setIsLoading(false);
    }
  }, [isDiscardedFinish, isExpireSoonFinish, isLowQuantityFinish, isLoading]);

  function initLoadingState() {
    setIsLoading(true);

    setIsDiscardedFinish(false);
    setIsExpireSoonFinish(false);
    setIsLowQuantityFinish(false);

    if (selectedLab) {
      const isAdmin =
        Array.isArray(memberships) &&
        memberships.some(
          (item) =>
            item.role_code === "lab_admin" && item.lab_id === selectedLab.id,
        );

      setIsLabAdmin(isAdmin);
    }
  }

  return (
    <>
      <div className={styles["main-page"]}>
        <h2 id="main-title">アラート</h2>
        <label>
          研究室
          <select
            value={selectedLab?.id ?? ""}
            onChange={(e) => {
              const labId = Number(e.target.value);
              const lab = userLabs.find((l) => l.id === labId) ?? null;
              setSelectedLab(lab);
            }}
            title="研究室を選択"
          >
            <option value="" disabled>
              研究室を選択
            </option>
            {userLabs.map((lab) => {
              const count = alertCountByLabs.get(lab.id) ?? 0;
              return (
                <option key={lab.id} value={lab.id}>
                  {lab.name}（{count}）
                </option>
              );
            })}
          </select>
        </label>
        {selectedLab != null && (
          <div>
            <LowQuantityList
              onFinish={() => setIsLowQuantityFinish(true)}
              isLabAdmin={isLabAdmin}
              selectedLab={selectedLab}
            />
            <DiscardedList
              onFinish={() => setIsDiscardedFinish(true)}
              isLabAdmin={isLabAdmin}
              selectedLab={selectedLab}
            />
            <ExpireSoonList
              onFinish={() => setIsExpireSoonFinish(true)}
              isLabAdmin={isLabAdmin}
              selectedLab={selectedLab}
            />
          </div>
        )}
      </div>
      {isLoading && <LoadingOverlay />}
    </>
  );
}

export default MainPage;
